export default {
  status: {
    pending: 'Venter på DNS',
    verified: 'Live',
    failed: 'Handling påkrævet',
  },
  summary: {
    preparing:
      'Recordsene for {{host}} er ved at blive klargjort. De vises her om cirka 15 minutter — eller med det samme, når du trykker på Tjek igen.',
    pending:
      'Venter på DNS-recordsene nedenfor. Det tager som regel et par minutter og kan tage op til 48 timer — vi bliver ved med at tjekke automatisk.',
    certificate_pending:
      'Recordsene er på plads. Certifikatet til {{host}} er ved at blive udstedt — det tager som regel et par minutter.',
    verified: 'Onlineshoppen er live på {{host}}.',
    serving: 'Onlineshoppen er live på {{serving_host}}, men {{host}} åbner den endnu ikke.',
    apex_elsewhere:
      'A-recorden på @ peger endnu ikke på shoppen. Hvis {{host}} viser et website, der skal blive der, så lad @ være som den er — shoppen fungerer på {{serving_host}}. Ellers skal du tilføje A-recorden nedenfor.',
    apex_held:
      '{{host}} bruges af et andet website på Vercel. Hvis {{host}} også skal åbne shoppen, skal du først fjerne domænet fra det website.',
    regressed:
      '{{host}} fungerede tidligere, men en record nedenfor består ikke længere kontrollen. Ret den hos DNS-udbyderen, og tryk derefter på Tjek igen.',
    record_elsewhere:
      'En record nedenfor peger et andet sted hen. Ret den hos DNS-udbyderen til den viste værdi, og tryk derefter på Tjek igen.',
    records_missing:
      'Recordsene nedenfor kan stadig ikke findes efter 48 timer. Kontrollér, at de er gemt for {{zone}} hos den udbyder, der administrerer zonens DNS. Hvis udbyderen ikke tillader ændringen, kan domænet være låst der.',
    certificate: {
      ownership_proof_required:
        '{{host}} er også tilknyttet en anden Vercel-konto, så restauranten skal bevise, at domænet tilhører den.',
      held_by_another_project:
        '{{host}} bruges stadig af et andet website på Vercel, så shoppen kan endnu ikke bruge det.',
      dns_correct_but_unconfigured: 'Recordsene er korrekte, men noget andet på {{host}} blokerer certifikatet.',
      name_mismatch: '{{host}} svarer stadig med et certifikat til et andet navn.',
      expired: 'Certifikatet for {{host}} er udløbet. Vi er blevet underrettet og arbejder på det.',
      expiring: 'Certifikatet for {{host}} udløber snart og er endnu ikke blevet fornyet. Vi arbejder på det.',
      attach_refused:
        'Vores hostingudbyder afviste at tilføje {{host}} hos dem. Vi er blevet underrettet og arbejder på det.',
      overdue: 'Certifikatet for {{host}} er stadig ikke udstedt efter 48 timer.',
      unknown: 'Certifikatet for {{host}} kunne ikke udstedes.',
    },
    certificate_see_row: 'Certifikatrækken nedenfor fortæller, hvad du skal gøre.',
  },
  instructions: {
    title: 'Sådan forbinder du {{host}}',
    step_provider: 'Log ind der, hvor DNS for {{zone}} administreres – som regel hos det firma, domænet er købt hos.',
    step_add: 'Tilføj hver post nedenfor præcis som vist: dens type, navn og værdi.',
    step_check: 'Gem, og tryk derefter på {{button}}. Vi tjekker også selv løbende.',
    tip_name:
      'De fleste udbydere vil kun have den del, der står før {{zone}}, i navnefeltet – her {{names}}. Det fulde navn vises også til udbydere, der kræver det.',
    tip_apex: '@ står for selve {{zone}}. Nogle udbydere lader i stedet navnefeltet stå tomt.',
    tip_apex_website:
      'Hvis {{zone}} allerede åbner en hjemmeside, flytter du {{zone}} væk fra den hjemmeside ved at pege @ på shoppen. Vil du beholde hjemmesiden der, så lad posterne på @ stå som de er – shoppen virker stadig på www.{{zone}} – eller forbind i stedet et subdomæne som order.{{zone}} til shoppen.',
    tip_existing:
      'Fjern alle andre A-, AAAA- eller CNAME-poster på {{name}}. To poster, der peger forskellige steder hen, får shoppen til kun at indlæse en del af tiden.',
    tip_cloudflare:
      'På Cloudflare skal disse poster sættes til kun DNS (grå sky). Når proxyen er slået til, kan ingen se, hvor de peger hen, og der kan ikke udstedes noget certifikat.',
    tip_locked:
      'Hvis udbyderen ikke tillader at tilføje eller ændre disse poster, kan domænet være låst, eller dets DNS kan administreres et andet sted. Udbyderen kan låse det op eller oplyse, hvor dets DNS administreres.',
  },
  records: {
    title: 'Poster for {{host}}',
  },
  separate_domains: {
    apex: 'Dette domæne er kun til onlineshoppen: shoppen bruger {{zone}} og www.{{zone}}. En hjemmeside skal bruge et andet navn – et subdomæne af {{zone}} eller et eget domæne.',
    subdomain: 'Dette domæne er kun til onlineshoppen. En hjemmeside kan bruge {{zone}} eller www.{{zone}}.',
  },
  load_error: 'Domænestatus kunne ikke indlæses.',
  no_access: 'Ingen adgang til domænestatus for denne restaurant.',
  polling_stopped: 'Denne side er holdt op med at opdatere sig selv. Tryk på Tjek igen for at opdatere den.',
  buttons: {
    check_again: 'Tjek igen',
    retry: 'Prøv igen',
  },
  toasts: {
    check_started: 'Tjekker posterne. Det kan tage et minut.',
    check_failed: 'Tjekket kunne ikke startes. Prøv igen.',
    check_too_soon: 'Netop tjekket. Vent et minut, før du tjekker igen.',
  },
};
